// extracted by mini-css-extract-plugin
module.exports = {"top_info_block":"top_info_block__odySxTNP4d4-w","info_desc":"info_desc__Yn3f2DzBNfItW","param_name":"param_name__g581J7m1vzCpl","param":"param__YSrW78IL9wlZx"};